const clickOutsideDirective = {
  mounted(el, binding) {
    // Asegurarse de que el valor es un objeto con 'handler' y opcionalmente 'ignore'
    const { handler, ignore } = typeof binding.value === 'object' 
      ? binding.value 
      : { handler: binding.value, ignore: [] };

    if (typeof handler !== 'function') {
      console.warn('[v-click-outside] El valor proporcionado debe ser una función o un objeto { handler: function, ignore: [HTMLElement] }');
      return;
    }

    // Asegurar que 'ignore' es un array
    const ignoreElements = Array.isArray(ignore) ? ignore : [ignore].filter(Boolean);

    el.__ClickOutsideHandler__ = event => {
      // Acceder al elemento real si es una ref de Vue
      const target = event.target;
      const elRef = el; // El elemento donde se aplica la directiva (dropdown panel)
      
      // Comprobar si el clic fue dentro del elemento principal
      const clickedInsideEl = elRef === target || elRef.contains(target);
      
      // Comprobar si el clic fue dentro de alguno de los elementos a ignorar
      const clickedInsideIgnore = ignoreElements.some(ignoreElRef => {
          const ignoreEl = ignoreElRef?.value || ignoreElRef; // Manejar refs de Vue y elementos directos
          return ignoreEl && (ignoreEl === target || ignoreEl.contains(target));
      });

      // Si el clic NO fue dentro del elemento principal NI dentro de los ignorados, ejecutar handler
      if (!clickedInsideEl && !clickedInsideIgnore) {
        handler(event);
      }
    };

    document.body.addEventListener('click', el.__ClickOutsideHandler__, true); // Usar captura para potencialmente interceptar antes
  },

  beforeUnmount(el) {
    // Eliminar el listener específico
    if (el.__ClickOutsideHandler__) {
      document.body.removeEventListener('click', el.__ClickOutsideHandler__, true);
      delete el.__ClickOutsideHandler__;
    }
  }
};

export { clickOutsideDirective as vClickOutside }; 